<template>
  <div class="spl-select-order">
    <second-menu-link-content>
      <template v-slot:header>
        <span>选品单</span>
      </template>
      <template v-slot:content>
        <div class="main">
          <div class="search">
            <el-form ref="form" :model="form" label-width="90px">
              <div class="flex">
                <el-form-item label="客户名称：">
                  <el-input class="white" v-model="form.name" clearable placeholder="请输入客户名称"></el-input>
                </el-form-item>
                <el-form-item label="供货商：">
                  <el-input
                    class="white"
                    v-model="form.supplierName"
                    clearable
                    placeholder="请输入供货商"
                  ></el-input>
                </el-form-item>
                <el-form-item label="订单状态：" prop="status">
                  <el-select v-model="form.status" clearable class="white">
                    <el-option
                      v-for="item in orderStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item label="商品名称：">
                  <el-input class="white" clearable v-model="form.goodsName" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="订单号：">
                  <el-input class="white" clearable v-model="form.code" placeholder="请输入订单号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button class="btn-blue" @click="search">筛选</el-button>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="table">
            <div class="table-title">
              <p class="order-detail">订单详情</p>
              <p class="order-rate">抽佣比例</p>
              <p class="order-time">预计直播时间</p>
              <p class="order-state">订单状态</p>
              <p class="order-supplier">供应商</p>
              <p class="order-username">客户名称</p>
            </div>
            <div class="table-list" v-for="(value,index) in selectionOrder" :key="index">
              <div class="time-code">
                <p class="time">{{value.time}}</p>
                <p class="code">订单编号：{{value.code}}</p>
                <!-- <p class="relation-select">
                  <el-button type="text" class="btn-text" @click="toRelationSelect">关联订单</el-button>
                </p> -->
              </div>
              <div class="order-content">
                <div class="goods-container">
                  <div class="goods-item" v-for="(item,i) in value.items" :key="i">
                    <div class="img-container">
                      <img class="img" :src="item.img" alt />
                    </div>
                    <div class="name-spec">
                      <p class="name">{{item.goodsName}}</p>
                      <p class="spec">{{item.specifications}}</p>
                    </div>
                    <div class="price">￥{{item.price}}</div>
                    <div class="ratio">×{{item.quantity}}</div>
                  </div>
                </div>
                <div class="rate">
                  <div
                    class="rate-item"
                    v-for="(item,i) in value.items"
                    :key="i"
                  >{{item.commissionRate}}%</div>
                </div>
                <div class="live-time flex1">{{value.liveTime}}</div>
                <div class="state flex1">{{value.statusName}}</div>
                <div class="supplier flex1">{{value.supplierName}}</div>
                <div class="username flex1">{{value.name}}</div>
              </div>
            </div>
          </div>
          <div class="pagination">
            <pagination-tpl
              @queryChange="updatePage"
              :pageSize="pageSize"
              :currentPage="page"
              :total="total"
            ></pagination-tpl>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import DBOrder from "models/db/order.js";
const dbOrder = new DBOrder();
export default {
  data() {
    return {
      form: {
        status: "",
        goodsName: "",
        code: "",
        name: "",
        supplierName: "",
      },
      searchForm: {
        status: "",
        goodsName: "",
        code: "",
        name: "",
        supplierName: "",
      },
      orderStatus: [
        {
          value: 0,
          label: "拒绝",
        },
        {
          value: 1,
          label: "待审核",
        },
        {
          value: 2,
          label: "待邀约",
        },
        {
          value: 3,
          label: "待确认邀约",
        },
        {
          value: 4,
          label: "待完成",
        },
        {
          value: 5,
          label: "邀约完成",
        },
        {
          value: 6,
          label: "已取消",
        },
        {
          value: 7,
          label: "待直播确认",
        },
        {
          value: 8,
          label: "完成",
        },
      ],
      selectionOrder: [],
      total: 0, // 数据总数量
      page: 1,
      pageSize: 20,
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
  },
  created() {
    this.getSelectionList();
  },
  methods: {
    getSelectionList() {
      let status = this.searchForm.status;
      let goodsName = this.searchForm.goodsName;
      let code = this.searchForm.code;
      let name = this.searchForm.name;
      let supplierName = this.searchForm.supplierName;
      let currentPage = this.page;
      let options = {
        status,
        goodsName,
        code,
        name,
        supplierName,
        currentPage
      }
      dbOrder
        .getSelectionOrderList(options)
        .then((res) => {
          if (res.success) {
            console.log(res);
            this.total = res.result.totalNum;
            let selectionOrder = [];
            res.result.items.map((value) => {
              let obj = {};
              obj.id = value.id;
              obj.time = this.fmtDate(value.createTime);
              obj.liveTime = this.fmtDate(value.liveTime);
              obj.code = value.code;
              obj.statusName = this.getCodeName(value.status);
              obj.status = value.status;
              obj.supplierName = value.supplierName;
              obj.name = value.name;
              obj.items = [];
              value.selectionOrderDetail.map((v) => {
                let object = {};
                object.img = v.goodsPic;
                object.goodsName = v.goodsName;
                object.price = v.price;
                object.quantity = v.quantity;
                object.commissionRate = v.commissionRate * 100;
                let itemTitle = JSON.parse(v.itemTitle);
                let specifications = "";
                for (let key in itemTitle) {
                  specifications += `,${itemTitle[key]}`;
                }
                object.specifications = specifications.substring(1);
                obj.items.push(object);
              });
              selectionOrder.push(obj);
            });
            this.selectionOrder = selectionOrder;
          }
        });
    },
    search() {
      this.page = 1;
      this.searchForm = this.form;
      this.getSelectionList();
    },
    // 根据订单状态返回对应的值
    getCodeName(status) {
      let statusName = [
        "拒绝",
        "待审核",
        "待邀约",
        "待确认邀约",
        "待完成",
        "邀约完成",
        "已取消",
        "待直播确认",
        "完成",
      ];
      return statusName[status];
    },
    toRelationSelect() {
      this.$router.push("/admin/order/select-form/relation-select");
    },
    // 时间格式转换
    fmtDate(date) {
      let dateFn = new Date(date);
      let yy = dateFn.getFullYear();
      let mm = dateFn.getMonth() + 1;
      let dd = dateFn.getDate();
      let hh =
        dateFn.getHours() < 10
          ? "0" + dateFn.getHours()
          : "" + dateFn.getHours();
      let xx =
        dateFn.getMinutes() < 10
          ? "0" + dateFn.getMinutes()
          : "" + dateFn.getMinutes();
      let ss =
        dateFn.getSeconds() < 10
          ? "0" + dateFn.getSeconds()
          : "" + dateFn.getSeconds();
      let time = yy + "-" + mm + "-" + dd + " " + hh + ":" + xx + ":" + ss;
      return time;
    },
    updatePage(data) {
      this.page = data.currentPage;
      this.getSelectionList();
    },
  },
};
</script>

<style lang="scss" scoped>
.spl-select-order {
  width: 100%;
  height: 100%;
  .main {
    .search {
      padding-top: 16px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px;
      margin-bottom: 16px;
      .el-form {
        .flex {
          display: flex;
          .el-input {
            width: 160px;
          }
          .el-select {
            width: 160px;
          }
        }
      }
    }
    .table {
      .table-title {
        height: 32px;
        background: rgba(245, 247, 250, 1);
        border-radius: 4px 4px 0 0;
        display: flex;
        align-items: center;
        text-align: center;
        font-size: 14px;
        color: #888888;
        margin-bottom: 16px;
        .order-detail {
          width: 420px;
        }
        .order-rate {
          flex: 1;
        }
        .order-time {
          flex: 1;
        }
        .order-state {
          flex: 1;
        }
        .order-supplier {
          flex: 1;
        }
        .order-username {
          flex: 1;
        }
      }
      .table-list {
        margin-bottom: 20px;
        .time-code {
          height: 34px;
          background: rgba(245, 247, 250, 1);
          border-radius: 4px 4px 0px 0px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: rgba(136, 136, 136, 1);
          padding-left: 20px;
          .time {
            margin-right: 20px;
          }
          .code {
            margin-right: 20px;
          }
        }
        .order-content {
          border: 1px solid #eff2f5;
          display: flex;
          .goods-container {
            width: 420px;
            border-right: 1px solid rgba(239, 242, 245, 1);
            .goods-item {
              margin: 6px 0;
              height: 70px;
              display: flex;
              align-items: center;
              padding-left: 20px;
              .img-container {
                width: 64px;
                height: 64px;
                display: flex;
                align-items: center;
                justify-content: center;
                .img {
                  max-width: 64px;
                  max-height: 64px;
                }
              }
              .name-spec {
                width: 198px;
                height: 50px;
                font-size: 12px;
                padding-left: 10px;
                box-sizing: border-box;
                .name {
                  height: 32px;
                  line-height: 16px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  margin-bottom: 2px;
                }
                .spec {
                  font-size: 12px;
                  height: 16px;
                  line-height: 16px;
                  color: #999999;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                }
              }
              .price {
                font-size: 12px;
                color: rgba(153, 153, 153, 1);
                padding-left: 14px;
                min-width: 64px;
              }
              .ratio {
                font-size: 12px;
                color: rgba(153, 153, 153, 1);
                padding-left: 10px;
              }
            }
          }
          .flex1 {
            flex: 1;
            border-right: 1px solid rgba(239, 242, 245, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            text-align: center;
          }
          .rate {
            flex: 1;
            border-right: 1px solid rgba(239, 242, 245, 1);
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            .rate-item {
              height: 82px;
              line-height: 82px;
              text-align: center;
            }
          }
        }
      }
      .table-list:last-child {
        margin-bottom: 0;
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
